import React, { useEffect, useState } from "react";
import styled from "styled-components";
import handBurger from "../mobile/icons/side-menu-bar.svg";
import github from "../mobile/icons/icons8_github_Side-bar.svg";
import linkein from "../mobile/icons/icons8_linkedin_Side-bar.svg";
import twitter from "../mobile/icons/icons8_twitter_Side-bar.svg";
import { motion } from "framer-motion";
import { useLocation, useNavigate } from "react-router-dom";

export default function NavBar({ scrollElement, setnav, nav }) {
  const location = useLocation();
  const navigate = useNavigate();
  function close() {
    if (nav == true) {
      setnav(false);
    }
  }
  function open() {
    if (location.pathname != "/") return;
    if (nav == false) {
      setnav(true);
    }
  }

  return (
    <Navbar>
      <div onClick={() => navigate("/")} className="logo">
        <span className="span">umar</span>
        <span className="span">spidey</span>
      </div>

      <div className={`nav-links ${nav ? "open" : "close-nav"}`}>
        <div onClick={close} className="close">
          <div></div>
          <div></div>
        </div>
        <ul className="ul">
          <li
            onClick={() => location.pathname == "/" && scrollElement("about")}
          >
            About
          </li>
          <li
            onClick={() => location.pathname == "/" && scrollElement("project")}
          >
            projects
          </li>
          <li
            onClick={() => location.pathname == "/" && scrollElement("contact")}
          >
            contact me
          </li>
        </ul>
        <div className="icons">
          <a href="http://github.com/iconicspidey" target="_blank">
            <img src={github} alt="" />
          </a>
          <a href="http://" target="_blank">
            <img src={linkein} alt="" />
          </a>
          <a href="http://twitter.com/iconicspidey" target="_blank">
            <img src={twitter} alt="" />
          </a>
        </div>
      </div>

      <img onClick={open} className="hand-burger" src={handBurger} alt="" />
    </Navbar>
  );
}

const Navbar = styled.nav`
  background-color: ${(props) => props.theme.colors.bgcolor};
  height: 100px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 35px;
  position: relative;

  .logo {
    color: ${(props) => props.theme.colors.primarycolor};
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 75px;
    height: 40px;
    outline: 2px solid ${(props) => props.theme.colors.border};
    border-radius: 1px;
    cursor: pointer;
    /* child styling */
    span:nth-child(2) {
      width: 100%;
      display: grid;
      place-items: center;
      text-transform: uppercase;
      background-color: ${(props) => props.theme.colors.border};
      font-size: 12.5px;
      font-weight: 900;
      letter-spacing: 0.5px;
    }
    span:nth-child(1) {
      letter-spacing: 2px;
      font-size: 18px;
      font-weight: 900;
      text-transform: uppercase;
      height: 30px;
    }
    /* end children styling */
  }
  /* burger svg */
  .hand-burger {
    height: 40px;
    width: 30px;
    cursor: pointer;
  }
  // styling the links
  .nav-links {
    position: absolute;
    width: 150px;
    height: 200px;
    outline: 2px solid #586f93;
    right: 34px;
    top: 34px;
    border-radius: 8px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-color: ${(props) => props.theme.colors.bgcolor};
    z-index: 100;
    /* icons  */
    .icons {
      display: flex;
      justify-content: space-around;
      margin-top: 0;
      a img {
        height: 20px;
        width: 20px;
      }
      padding-bottom: 10px;
    }
    .ul {
      padding-left: 20px;
      /* margin-top: 30px; */
      display: flex;
      flex-direction: column;
      justify-content: space-between;

      li {
        cursor: pointer;
        margin: 20px 0;
        list-style: none;
        font-size: 16px;
        font-weight: 500;
        color: ${(props) => props.theme.colors.secondarycolor};
        text-transform: capitalize;
      }
    }
    .close {
      right: 10px;
      top: 20px;
      position: absolute;
      z-index: 100;
      width: 50px;
      height: 50px;
      cursor: pointer;
      div {
        width: 25px;
        background-color: ${(props) => props.theme.colors.primarycolor};
        height: 3px;
        border-radius: 3px;
        position: absolute;
        top: 0;
        right: 0;
      }
      div:nth-child(1) {
        transform: rotateZ(45deg);
      }
      div:nth-child(2) {
        transform: rotateZ(-45deg);
      }
    }
  }
  .open {
    display: block;
  }
  .close-nav {
    display: none;
  }
  @media (min-width: 800px) {
    .nav-links {
      top: 20px;
      height: 50%;
      width: 500px;
      outline: none;
      /* border: 2px solid red; */

      .ul {
        width: 100%;
        display: flex;
        justify-content: space-evenly;
        flex-direction: row;
        align-items: center;
        top: 100px;
        /* border: 2px solid red; */
        li {
          &::after {
            content: "";
            width: 0%;
            height: 3px;
            background-color: ${(props) => props.theme.colors.primarycolor};

            display: block;
          }
          &:hover::after {
            width: 100%;
            transition: width ease-in 0.2s;
          }
        }
      }
      .close {
        display: none;
      }
      .icons {
        display: none;
      }
    }
    .hand-burger {
      display: none;
    }
    .close-nav {
      display: block;
    }
  }
`;
